import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const FOUNDER_IMAGE = 'https://res.cloudinary.com/dxit9ltm4/image/upload/v1776002909/clothes_change_ai_1775988373398_e7b5gg.jpg';

const expertiseAreas = [
  { icon: 'ri-robot-line', key: 'founder.aiIT' },
  { icon: 'ri-code-s-slash-line', key: 'founder.softwareDev' },
  { icon: 'ri-global-line', key: 'founder.webDev' },
  { icon: 'ri-bar-chart-2-line', key: 'founder.digitalMarketing' },
  { icon: 'ri-settings-3-line', key: 'founder.businessAutomation' },
  { icon: 'ri-service-line', key: 'founder.consulting' },
];

export default function FounderSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-32 h-32 bg-clairBlue-200/40 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-darkBlue-200/40 rounded-full blur-3xl"></div>
            <img
              src={FOUNDER_IMAGE}
              alt="Bienvenu Masengesho - Founder & CEO of BientoMart"
              className="relative rounded-3xl shadow-2xl w-full h-auto object-cover object-top"
              loading="lazy"
            />
          </div>
          <div>
            <span className="inline-block text-clairBlue-500 text-xs font-bold uppercase tracking-widest mb-4 bg-clairBlue-50 px-4 py-1.5 rounded-full">
              {t('founder.label')}
            </span>
            <h2 className="font-display text-4xl font-bold text-darkBlue-500 mb-2">
              {t('founder.title')}
            </h2>
            <p className="text-clairBlue-600 font-semibold text-lg mb-4">
              {t('founder.subtitle')}
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              {t('founder.heroBio')}
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-8">
              {expertiseAreas.map((area) => (
                <div
                  key={area.key}
                  className="flex items-center gap-3 bg-gray-50 rounded-xl p-3 border border-gray-100"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-clairBlue-50 rounded-lg text-clairBlue-500">
                    <i className={`${area.icon} text-lg`}></i>
                  </div>
                  <span className="text-sm font-medium text-darkBlue-500">{t(area.key)}</span>
                </div>
              ))}
            </div>
            <div className="flex flex-wrap gap-4">
              <Link
                to="/bienvenu-masengesho"
                className="inline-flex items-center gap-2 px-6 py-3 bg-clairBlue-300 hover:bg-clairBlue-200 text-darkBlue-500 font-bold rounded-xl transition-all hover:scale-105"
              >
                {t('founder.viewProfile')}
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/services"
                className="inline-flex items-center gap-2 px-6 py-3 bg-darkBlue-500 hover:bg-darkBlue-600 text-white font-bold rounded-xl transition-all hover:scale-105"
              >
                {t('founder.cta')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
